// partners.jsx
import React from 'react';
import './partners.css';
import Sidebar from '../sidebar/sidebar';
import image from "../../assets/Large-screens/10.png"


const Partners = () => {
  return (
    <div className="home-container">
      <Sidebar />
      <div className="home-content">
        <img
          src={image} // Replace with your image URL
          alt="Partners"
          className="home-image"
        />
      </div>
    </div>
  );
};

export default Partners;
